import { authHeader } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// ============================================================
// GENERACIÓN DE IMAGEN (NUEVO ENDPOINT SEPARADO)
// ============================================================
export async function generarImagen(data) {
  const response = await fetch(`${API_URL}/api/v1/contenido/generar-imagen`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al generar la imagen');
  }

  return response.json();
}

// ============================================================
// GENERACIÓN DE VIDEO (NUEVO ENDPOINT SEPARADO)
// ============================================================
export async function generarVideo(data) {
  const response = await fetch(`${API_URL}/api/v1/contenido/generar-video`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al generar el video');
  }

  return response.json();
}

// ============================================================
// FUNCIONES GENÉRICAS (mantenidas para compatibilidad)
// ============================================================
export async function generarContenido(data) {
  // Por compatibilidad, redirigimos a generarImagen (el endpoint más común)
  // Si quieres que funcione para video, deberías detectar el tipo y redirigir
  return generarImagen(data);
}

// ============================================================
// LISTAR Y ELIMINAR CONTENIDO
// ============================================================
export async function listarContenidoPorCampania(campaniaId) {
  const response = await fetch(`${API_URL}/api/v1/contenido/campania/${campaniaId}`, {
    method: 'GET',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar el contenido');
  }

  return response.json();
}

export async function listarImagenesPorCampania(campaniaId) {
  const response = await fetch(`${API_URL}/api/v1/contenido/campania/${campaniaId}/imagenes`, {
    method: 'GET',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar las imágenes');
  }

  return response.json();
}

export async function listarVideosPorCampania(campaniaId) {
  const response = await fetch(`${API_URL}/api/v1/contenido/campania/${campaniaId}/videos`, {
    method: 'GET',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar los videos');
  }

  return response.json();
}

export async function eliminarContenido(contenidoId) {
  const response = await fetch(`${API_URL}/api/v1/contenido/${contenidoId}`, {
    method: 'DELETE',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al eliminar el contenido');
  }

  return true;
}

// ============================================================
// 🔥 NUEVO ENDPOINT ADMINISTRATIVO: HISTORIAL DE CRÉDITOS
// ============================================================
export async function obtenerHistorialCreditosAdmin({
  usuarioId = null,
  email = null,
  fechaDesde = null,
  fechaHasta = null,
  skip = 0,
  limit = 100
} = {}) {
  let url = `${API_URL}/api/v1/contenido/admin/historial-creditos?skip=${skip}&limit=${limit}`;
  
  if (usuarioId) url += `&usuario_id=${usuarioId}`;
  if (email) url += `&email=${encodeURIComponent(email)}`;
  if (fechaDesde) url += `&fecha_desde=${fechaDesde}`;
  if (fechaHasta) url += `&fecha_hasta=${fechaHasta}`;

  const response = await fetch(url, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener el historial de créditos');
  }

  return response.json();
}